export type NavigationItem = {
  title: string;
  href: string;
  /** Additional route patterns that should mark this nav item as active */
  matchPatterns?: string[];
  /** If true, this item requires a program ID to be rendered (href will be a function) */
  requiresProgramId?: boolean;
};

export const dashboardNavigationItemsData: NavigationItem[] = [
  { title: "Dashboard", href: "/dashboard", matchPatterns: ["/dashboard/:id"] },
  { title: "Support", href: "/support" },
  { title: "Settings", href: "/account" },
];

/**
 * Profile navigation item - always visible, requires programId for href.
 * Rendered separately from the main navigation items.
 */
export const profileNavigationItem: NavigationItem = {
  title: "Profile",
  href: "/program/:id/profile",
  matchPatterns: ["/program/:id/profile"],
  requiresProgramId: true,
};

export default dashboardNavigationItemsData;


